import React, { Component } from "react"
import { ComboBox } from "./ComboBox";
import { AdminTaskDetail } from "./Task/AdminTaskDetail";
import './Task/task.css'

export class AdminTaskGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true, data: null,
            optionsState: []
        }
        //this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    static renderConditionTask(e, inTime) {
        if (inTime && e == 'Nueva') {
            return <div className="condition-task in-time">{e}</div>
        } else {
            switch (e) {
                case 'Nueva':
                    return <div className="condition-task new">{e}</div>
                    break;
                case 'En curso':
                    return <div className="condition-task doing">{e}</div>
                    break;
                case 'Finalizada':
                    return <div className="condition-task finished">{e}</div>
                    break;
                case 'Aplazada':
                    return <div className="condition-task poster">{e}</div>
                    break;
                case 'Aprobar':
                    return <div className="condition-task poster">Aprobada</div>
                    break;
                default:
            }
        }
    }

    generateOptionState(data) {

        this.setState({ optionsState: [] });

        this.state.optionsState.push({ id: 'Nueva', value: 'Nueva' });
        this.state.optionsState.push({ id: 'En curso', value: 'En curso' });
        this.state.optionsState.push({ id: 'Finalizada', value: 'Finalizada' });
        this.state.optionsState.push({ id: 'Aplazada', value: 'Aplazada' });

        let admin = data.roles.find((a) => { return a == 'Administrador' })
        if (admin) {
            this.state.optionsState.push({ id: 'Aprobar', value: 'Aprobado' });
            //this.state.optionsState.push({ id: 'Cerrar proceso', value: 'Cerrar proceso' });
        }

        let coordinator = data.roles.find((a) => { return a == 'Director' })
        if (coordinator) {
            this.state.optionsState.push({ id: 'Aprobar', value: 'Aprobado' });
        }
    }

    render() {
        return (
            <div className="wrapp-calendar">

                <input id="btnForceTask" type="button" style={{ display: 'none' }} onClick={(event) => {

                    this.setState({ renderDetail: true });
                    
                }}></input>

                <div className="filter">

                    <fieldset className="row">
                        <legend>Filtrar</legend>
                        {this.isAdmin ? <div className="group-control col-md-6">
                            <b>Responsable</b>
                            <ComboBox data={this.users} id="comboUser"></ComboBox>
                        </div> : <div></div>
                        }


                        <div className="group-control col-md-6">
                            <b>Estado</b>
                            <ComboBox data={[{ id: 'Nueva', value: 'Nueva' }, { id: 'En curso', value: 'En curso' }, { id: 'Finalizada', value: 'Finalizada' }, { id: 'Aplazada', value: 'Aplazada' }, { id: 'Aprobar', value: 'Aprobada' }]} id="comboFilterCondition" lot={false} />
                        </div>
                        <div className="group-control col-md-6">
                            <b>Titulo o descripción</b>
                            <input type="text" className="form-control" name="filterText" />
                        </div>
                        <div className="group-control col-md-12 mt-2">
                            <input type="button" value="Filtrar" className="btn btn-primary" onClick={this.getData.bind(this)} />
                        </div>
                    </fieldset>

                </div>

                <a href="/nueva-tarea" className="btn btn-primary mt-5">Crear tarea</a>
                <div id="calendar" className="mt-3"></div>

                <input id="openDetailTask" type="button" class="btn btn-primary" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#modalDetailTask" hidden>
                    
                </input>

                {this.state.renderDetail ? <AdminTaskDetail taskId={window['taskId']} handlerCloseModal={() => { this.setState({ renderDetail: false }); /*this.getData();*/ }} /> : null}
            </div>
        );
    }

    async getData() {
        this.setState({ loading: true });

        var model = {
            UserId: document.querySelector('#comboUser select') && document.querySelector('#comboUser select').value ? parseInt(document.querySelector('#comboUser select').value) : null,
            Condition: document.querySelector('#comboFilterCondition select') ? document.querySelector('#comboFilterCondition select').value : '',
            Text: document.querySelector('input[name=filterText]') ? document.querySelector('input[name=filterText]').value : '',
            ShowApprobed: document.querySelector('input[name=showApproved]') ? document.querySelector('input[name=showApproved]').checked : false
        }

        const request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(model)
        }

        const response = await fetch('Task/GetAllTaskGrid', request);
        if (response.redirected) {
            window.location.href = response.url;
        }

        const data = await response.json();
        this.generateOptionState(data);
        this.setState({ loading: false, data: data });
        window.displayTasks(data);
    }
}